import { apiClient } from '../api/apiClient'
import { User, LoginForm, ApiResponse } from '@/types'
import { ENDPOINTS } from '@/config/api'

interface LoginResponse {
  access_token: string
  token_type: string
  expires_in: number
  user: User
}

class AuthService {
  async login(credentials: LoginForm): Promise<LoginResponse> {
    const response = await apiClient.post<ApiResponse<LoginResponse>>(
      ENDPOINTS.auth.login,
      credentials
    )
    
    if (response.data.success) {
      // Store token in localStorage
      localStorage.setItem('access_token', response.data.data.access_token)
      return response.data.data
    }
    
    throw new Error(response.data.message || 'Login failed')
  }

  async azureLogin(azureToken: string): Promise<LoginResponse> {
    const response = await apiClient.post<ApiResponse<LoginResponse>>(
      ENDPOINTS.auth.azureLogin,
      { azure_token: azureToken }
    )
    
    if (response.data.success) {
      localStorage.setItem('access_token', response.data.data.access_token)
      return response.data.data
    }
    
    throw new Error(response.data.message || 'Azure login failed')
  }

  async getCurrentUser(): Promise<User> {
    const response = await apiClient.get<ApiResponse<User>>(ENDPOINTS.auth.me)
    
    if (response.data.success) {
      return response.data.data
    }
    
    throw new Error(response.data.message || 'Failed to get user info')
  }

  async logout(): Promise<void> {
    try {
      await apiClient.post(ENDPOINTS.auth.logout)
    } catch (error) {
      console.error('Logout API call failed:', error)
    } finally {
      // Always remove token from localStorage
      localStorage.removeItem('access_token')
    }
  }

  getToken(): string | null {
    return localStorage.getItem('access_token')
  }

  isAuthenticated(): boolean {
    return !!this.getToken()
  }
}

export const authService = new AuthService()
